import { MouseEvent } from 'react';

const stopEventPropagation = (event: MouseEvent<HTMLElement>) => {
	event.preventDefault();
	event.stopPropagation();
};

export default stopEventPropagation;
